import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  AiOutlineHome,
  AiOutlineMessage,
  AiOutlineLogin,
  AiOutlineLogout,
} from "react-icons/ai";
import { FiUsers } from "react-icons/fi";
import { BsPerson, BsPersonAdd } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { logout } from "../../features/auth/authSlice";
import UserSuggestions from "../UserSuggestions/UserSuggestions";
import UserFriends from "../UserFriends/UserFriends";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // get the token from the redux store
  const { isLoggedIn, token } = useSelector((state) => state.auth);

  // state to store the user suggestions
  const [suggestions, setSuggestions] = useState([]);

  //state to store friends
  const [friends, setFriends] = useState([]);

  // function to logout the user and clear the token from the redux store
  const logoutHandler = () => {
    dispatch(logout());
    toast.success("Logged out successfully");
    navigate("/login");
  };
  // function to get the user suggestions
  const getUserSuggestions = async () => {
    // if the token is not present, return
    if (!token) return;
    // make a get request to the backend to get the user suggestions
    const response = await axios
      .get(`${BACKEND_URL}/users/get-suggestions`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        // if there is an error, show the error message
        toast.error(err.response.data.message);
      });

    // if the response is successful, set the suggestions
    if (response) {
      setSuggestions(response.data.users);
    }
  };

  const getFriends = async () => {
    // if the token is not present, return
    if (!token) return;
    // make a get request to the backend to get the user suggestions
    const response = await axios
      .get(`${BACKEND_URL}/users/friends/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        // if there is an error, show the error message
        toast.error(err.response.data.message);
      });

    // if the response is successful, set the suggestions
    if (response) {
      const slicedFriends = response.data.friends.slice(0, 3);
      setFriends(slicedFriends);
    }
  };

  // get the user suggestions on component mount and unmount and when the token changes
  useEffect(() => {
    getUserSuggestions();
    getFriends();

    return () => {
      setSuggestions([]);
      setFriends([]);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div>
      <div className="py-4 pl-2 fixed w-64 text-white h-full">
        <div className="bg-primary px-3 py-4 rounded-md">
          <h1 className="text-3xl font-[700]">UniPals</h1>
        </div>
        <div
          className={`bg-primary px-3 my-2 py-6 flex flex-col gap-4 rounded-md ${
            !isLoggedIn && "h-[90%]"
          }`}
        >
          {isLoggedIn && (
            <Link
              to="/"
              className="flex items-center gap-2 text-xl transition-all duration-300 ease-in hover:text-gray-100"
            >
              <AiOutlineHome />
              Home
            </Link>
          )}
          {isLoggedIn && (
            <Link
              to="/messages"
              className="flex items-center gap-2 text-xl transition-all duration-300 ease-in hover:text-gray-100"
            >
              <AiOutlineMessage />
              Messages
            </Link>
          )}
          {isLoggedIn && (
            <Link
              to="/friends"
              className="flex items-center gap-2 text-xl transition-all duration-300 ease-in hover:text-gray-100"
            >
              <FiUsers />
              Friends
            </Link>
          )}
          {/* // if the user is logged in, show the profile link, else show the login and signup links */}
          {isLoggedIn && (
            <Link
              to="/profile"
              className="flex items-center gap-2 text-xl transition-all duration-300 ease-in hover:text-gray-100"
            >
              <BsPerson />
              Profile
            </Link>
          )}
          {/* // if the user is not logged in, show the login and signup links */}
          {!isLoggedIn && (
            <Link
              to="/login"
              className="flex items-center gap-2 text-xl transition-all duration-300 ease-in hover:text-gray-100"
            >
              <AiOutlineLogin />
              Login
            </Link>
          )}
          {!isLoggedIn && (
            <Link
              to="/signup"
              className="flex items-center gap-2 text-xl transition-all duration-300 ease-in hover:text-gray-100"
            >
              <BsPersonAdd />
              Signup
            </Link>
          )}
          {isLoggedIn && (
            <button
              className="flex items-center gap-2 text-xl transition-all duration-300 ease-in hover:text-gray-100"
              onClick={logoutHandler}
            >
              <AiOutlineLogout />
              Logout
            </button>
          )}
        </div>
        {friends && friends.length > 0 && (
          <div className="bg-primary px-3 py-4 rounded-md">
            <UserFriends friends={friends} />
          </div>
        )}
        {suggestions && suggestions.length > 0 && (
          <div className="bg-primary px-3 py-4 rounded-md mt-2">
            <UserSuggestions suggestions={suggestions} />
          </div>
        )}
      </div>
      <div className="w-64"></div>
    </div>
  );
};

export default Sidebar;
